import type { ReactNode } from 'react';

export type BadgeTone = 'default' | 'ok' | 'warn' | 'err' | 'info' | 'accent';

interface Props {
  tone?: BadgeTone;
  children: ReactNode;
}

const TONE_STYLE: Record<BadgeTone, { bg: string; color: string }> = {
  default: { bg: 'var(--surface-2)', color: 'var(--text-2)' },
  ok: { bg: 'var(--ok-soft)', color: 'var(--ok)' },
  warn: { bg: 'var(--warn-soft)', color: 'var(--warn)' },
  err: { bg: 'var(--err-soft)', color: 'var(--err)' },
  info: { bg: 'var(--info-soft)', color: 'var(--info)' },
  accent: { bg: 'var(--accent-soft)', color: 'var(--accent-strong)' },
};

export function Badge({ tone = 'default', children }: Props) {
  const { bg, color } = TONE_STYLE[tone];
  return (
    <span
      className="inline-flex items-center gap-1.5 font-medium text-[11.5px] leading-none px-2 py-1 rounded-full border"
      style={{
        background: bg,
        color,
        borderColor: tone === 'default' ? 'var(--border)' : 'transparent',
      }}
    >
      {children}
    </span>
  );
}
